import { createTokenRefresher } from '@/shared/api';
import { env } from '@/shared/config';
import { getRefreshToken, useAuthStore } from './auth.store';

/**
 * 앱 전역 단일 재발급기 — tRPC 자동 재발급 링크와 화면 코드(온보딩 등)가 공유한다.
 *
 * 인스턴스가 하나여야 단일 비행(single-flight)이 전 경로에 걸쳐 성립한다.
 */
export const refreshSession = createTokenRefresher({
  apiUrl: env.VITE_API_URL,
  getRefreshToken,
  onTokens: (tokens) => useAuthStore.getState().setTokens(tokens),
});
